<template>
  <v-row>
    <v-col cols="12" offset-lg="1" lg="7" class="pr-3">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-4" />
      <v-card>
        <v-img :src="benefit_url" height="300px" />
        <div>
          <v-divider />
        </div>
        <v-card-title>
          <div class="headline theme-text">{{ benefit.name }}</div>
        </v-card-title>
        <v-card-text>
          <div class="title grey--text text--darken-3 font-weight-medium mt-2">
            {{ benefit.title }}
          </div>
          <div class="subtitle-1 grey--text mt-4 text--darken-3">
            {{ benefit.information }}
          </div>
          <div
            v-if="benefit.discount_code"
            class="body-1 grey--text text--darken-3 mt-4 text-uppercase"
          >
            Discount Code: {{ benefit.discount_code }}
          </div>
          <div class="title grey--text text--darken-3 font-weight-medium mt-2">
            Category
          </div>
          <div>
            <div>Offering type : {{ benefitType(benefit.type) }}</div>
            <div>Industry category : {{ benefit.category }}</div>
          </div>
          <div v-if="alreadyActive" class="my-9">
            <v-btn
              class="info rounded-sm"
              depressed
              @click="contactCompany"
              large
            >
              <span v-if="benefit.redirect_link !== ''">View Offer</span>
              <span v-else>Contact company</span>
            </v-btn>
            <span class="font-weight-bold subtitle-1 ml-5">
              {{ benefit.redirect_link !== "" ? "" : "Company contacted" }}
            </span>
          </div>
          <v-btn
            class="info rounded-sm my-9"
            v-else
            depressed
            @click="contactCompany"
            large
          >
            <span v-if="benefit.redirect_link !== ''">View Offer</span>
            <span v-else>Contact company</span>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>

    <v-dialog v-model="redirectDialog" persistent max-width="400">
      <v-card flat>
        <v-card-title class="headline pt-4 theme white--text">
          <span>Proceed to offer</span>
          <v-spacer />
          <v-btn icon @click="redirectDialog = !redirectDialog">
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-3 body-2">
          <div class="body-2">
            You will be redirected to the provider's website.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="save rounded-sm white--text"
            text
            @click="saveRedirectInfo"
            >Go to offer</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="offerDialog" persistent max-width="700">
      <v-card flat>
        <v-card-title class="headline pt-4 theme white--text">
          <span>Contact me</span>
          <v-spacer />
          <v-btn icon @click="offerDialog = !offerDialog">
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-3 body-2">
          <template>
            <v-stepper v-model="e1" class="elevation-0">
              <v-stepper-header class="elevation-0">
                <v-stepper-step :complete="e1 > 1" step="1" color="theme"
                  >Message to the provider
                </v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="e1 > 2" step="2" color="theme"
                  >Verify
                </v-stepper-step>
              </v-stepper-header>
              <v-divider />
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card flat>
                    <v-card-text class="pt-0">
                      <div class="body-1">
                        We will send a request to a service provider which will
                        contact you for more details.
                      </div>

                      <v-form ref="form" valid="validation">
                        <v-textarea
                          placeholder="Please provide more info regarding...."
                          label="Message"
                          hint="If you want to request any additional information from the service provider"
                          persistent-hint
                          v-model="comment"
                          class="mb-n1"
                        />
                        <v-checkbox
                          :rules="[validationRules.required]"
                          v-model="approval"
                          label="Consent to share your contact information with provider"
                        />
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        depressed
                        color="action white--text rounded-sm"
                        @click="validateForm"
                        >Continue
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-list subheader three-line>
                    <v-list-item class="mt-n5 ml-n3" v-if="comment">
                      <v-list-item-content>
                        <v-list-item-title class="theme-text"
                          >Message to provider</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          comment
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="mt-n3 ml-n3">
                      <v-list-item-content>
                        <v-list-item-title class="theme-text text-capitalize"
                          >provider details</v-list-item-title
                        >
                        <v-list-item-subtitle class="mt-1"
                          >Provider name:
                          {{ provider.name }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle class="mt-1"
                          >Location:
                          {{ provider.location }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle class="mt-1"
                          >Provider email:
                          {{ provider.contact_email }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-row class="mt-5">
                      <v-col cols="12" class="mt-n6">
                        <v-btn text @click="e1 = 1">back</v-btn>
                        <v-btn
                          depressed
                          style="float: right"
                          color="save white--text rounded-sm "
                          @click="saveOfferInfo"
                          >Send
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-col class="mt-11" cols="12" lg="3">
      <v-col cols="12">
        <v-card>
          <v-list-item>
            <v-list-item-content>
              <!--              <div class="overline">-->
              <!--                <span class="title font-weight-regular  theme-text">Provider details</span>-->
              <!--              </div>-->
              <v-list-item-title class="headline text-capitalize mb-1 mt-n4">
                {{ provider.name }}
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-avatar v-if="provider.logo_url" tile size="100">
              <v-img :src="provider.logo_url"></v-img>
            </v-list-item-avatar>
            <v-list-item-avatar tile size="100" grey v-else>
              <v-icon size="70">business</v-icon>
            </v-list-item-avatar>
          </v-list-item>

          <v-card-text>
            <div class="body-2 mb-4">
              {{ provider.description }}
            </div>
            <div>
              <div class="font-weight-bold body-1">Company Website</div>
              <div>{{ provider.url ? provider.url : "-" }}</div>
            </div>
            <div>
              <div class="font-weight-bold body-1 mt-3">Industry Category</div>
              <div>
                {{ benefit.category ? benefit.category : "-" }}
              </div>
            </div>
            <div>
              <div class="font-weight-bold body-1 mt-3">HQ Location</div>
              <div>
                {{ provider.location ? provider.location : "" }}
                {{ provider.state ? `, ${provider.state}` : "" }}
              </div>
            </div>
            <div>
              <div class="font-weight-bold body-1 mt-3">Contact details</div>
              <div>
                {{ provider.contact_email ? provider.contact_email : "-" }}
              </div>
            </div>

            <div>
              <v-btn
                small
                class="text-theme ml-n3 mt-4"
                @click="providerDetails"
                text
                >Company profile</v-btn
              >
            </div>
          </v-card-text>
        </v-card>

        <v-card class="pa-1 mt-4" v-if="userInfo.role === 'HR'">
          <v-card-text class="pa-2">
            <div class="grey--text text--darken-2">
              Become a partner and showcase your offers and services on our
              platform.
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              style="float: right"
              :ripple="false"
              depressed
              class="action white--text rounded-sm pt-0 mt-0"
              @click="offerManagement"
              >Advertise on our platform
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-col>
    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: Component.Protected.Benefit.OnBoarding,
  computed: {
    ...mapGetters(["userInfo", "companyInfo"]),
    benefit_url() {
      if (this.benefit && this.benefit.url !== "") {
        return this.benefit.url;
      } else {
        return "https://cdn.vuetifyjs.com/images/parallax/material2.jpg";
      }
    },
  },
  data: () => ({
    breadcrumbs: Breadcrumbs.Benefit.Details,
    benefit: {},
    provider: {},
    alreadyActive: false,
    approval: false,
    comment: "",
    redirectDialog: false,
    offerDialog: false,
    types: Constants.Benefits.Type.Select,
    e1: 1,
    validation: true,
  }),
  methods: {
    benefitType(type) {
      if (type) {
        return type.length === 1
          ? this.types.filter((e) => e.value == type[0]).map((e) => e.name)[0]
          : this.types[1].name;
      } else {
        return this.types[1].name;
      }
    },
    providerDetails() {
      this.$router.push({
        name: Component.Protected.Benefit.Provider.Profile,
        params: { id: this.provider.id },
      });
    },
    offerManagement() {
      this.$router.push({ name: Component.Protected.Benefit.Provider.Info });
    },
    getBenefitDetails() {
      this.$store
        .dispatch(Actions.Benefits.ProductDetails, this.$route.params.id)
        .then((r) => {
          if (r.status === 200 && r.data) {
            this.benefit = r.data.benefit;
            this.provider = r.data.provider;
            this.alreadyActive = r.data.active;
          }
        })
        .catch((err) => {
          console.error(Constants.Benefits.Messages.Error.Get, err);
          this.snackbar = true;
          this.snackbarMessage = Constants.Benefits.Messages.Error.Get;
        });
    },
    contactCompany() {
      if (!this.provider || !this.benefit) {
        return false;
      }
      // if the offer is a redirect type then log the request and redirect
      if (this.benefit.redirect_link) {
        this.redirectDialog = true;
      } else {
        this.offerDialog = true;
      }
    },

    validateForm() {
      if (this.$refs.form.validate()) {
        this.e1 = 2;
      }
    },
    saveRedirectInfo() {
      this.$store
        .dispatch(Actions.Benefits.ActivateOffer, {
          user_id: parseInt(this.userInfo.userID),
          offer_id: parseInt(this.benefit.id),
          offer_name: this.benefit.name,
          provider_id: parseInt(this.provider.id),
          provider_name: this.provider.name,
          offer_type:
            this.benefit.type && this.benefit.type.length > 0
              ? this.benefit.type.join(",")
              : this.types[1],
          offer_category: this.benefit.category,
          approval: true,
          comment: this.comment ? this.comment : "",
          redirect_link: this.benefit.redirect_link,
          company_id: parseInt(this.companyInfo.companyId),
        })
        .then((r) => {
          if (r.status === 200) {
            this.redirectDialog = false;
            window.open(this.benefit.redirect_link, "_blank");
          }
        });
    },
    saveOfferInfo() {
      this.$store
        .dispatch(Actions.Benefits.ActivateOffer, {
          user_id: parseInt(this.userInfo.userID),
          offer_id: parseInt(this.benefit.id),
          offer_name: this.benefit.name,
          provider_id: parseInt(this.provider.id),
          provider_name: this.provider.name,
          offer_type:
            this.benefit.type && this.benefit.type.length > 0
              ? this.benefit.type.join(",")
              : this.types[1],
          offer_category: this.benefit.category,
          approval: this.approval,
          comment: this.comment ? this.comment : "",
          redirect_link: this.benefit.redirect_link,
          company_id: parseInt(this.companyInfo.companyId),
        })
        .then((r) => {
          if (r.status === 200) {
            this.offerDialog = false;
          }
        })
        .finally(() => {
          this.getBenefitDetails();
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    setup() {
      this.getBenefitDetails();
    },
  },
  created() {
    if (!this.$route.params.id) {
      this.goBack();
      return false;
    }
    if (this.userInfo && this.userInfo.role) {
      this.getBenefitDetails();
    } else {
      this.$store
        .dispatch(Actions.Firebase.UserInfo)
        .then(() => this.getBenefitDetails());
    }
  },
};
</script>